import { useTranslation } from 'react-i18next';
import styles from './AccountVerification.module.css';
import CompletedIcon from '../../components/icons/CompletedIcon';
import { useSelector } from 'react-redux';
import WarningIconVerification from '../../components/icons/WarningIconVerification';

const AccountPercentage = ({ onClick, percentage }) => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.associates.user);
  const isOldUser = useSelector((state) => state.associates.user.isOldUser);
  const kycStatusCard = (user?.verificationUser).find((i) => i.type === 'KYC')?.status;
  const methodWithdraw = (user?.verificationUser).find(
    (i) => i.type === 'WITHDRAWAL_METHOD',
  )?.status;

  return (
    <div
      className={styles.verificationItemNone}
      style={{ display: 'flex', flexWrap: 'wrap' }}
      onClick={onClick}
    >
      <div className={styles.iconContainer}>
        <CompletedIcon className={styles.iconCompleted} />
      </div>

      <div className={styles.content}>
        <div className='bold font-small'>
          {t('yourAccountIsVerified', { percentage: percentage })}
        </div>

        <div className='text-secondary font-small mt-1 mb-1'>
          {t('completeVerificationFeatures')}
        </div>
      </div>

      <div className={styles.progressSection} style={{ flexBasis: '100%' }}>
        <div className={styles.progressBarWrapper}>
          <div className={styles.progressBar}>
            <div className={styles.progressFill} style={{ width: `${percentage}%` }}>
              <div className={styles.progressShine}></div>
            </div>
          </div>
          {percentage < 100 && <div className={styles.progressPulse}></div>}
        </div>
      </div>
      {((methodWithdraw === 'PENDING' && isOldUser) ||
        (kycStatusCard === 'PENDING' && isOldUser)) && (
        <div className={styles.mercadoPagoAlert}>
          <div className={styles.alertIconWrapper}>
            <WarningIconVerification size={'22'}></WarningIconVerification>
          </div>
          <div >
            <div className={`bold font-tiny  ${styles.alertTitle}`}>
              {' '}
              {t('completeYourCommissions')}
            </div>
            {methodWithdraw === 'PENDING' && isOldUser && (
              <div className={`font-tiny ${styles.alertDescription}`}>• {t('LinkAccount')} {t(`WITHDRAWAL_METHOD_TYPE.${user?.withdrawalMethod}`)}</div>
            )}
            {kycStatusCard === 'PENDING' && isOldUser && (
              <div className={`font-tiny ${styles.alertDescription}`}>• {t('KYC.title')}</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountPercentage;
